import Mobiles_JawAndCone_UD210 from './icon-images/Mobiles_JawAndCone_UD210.png';

export const getImageMobileJawAndCone = () => {
  return Mobiles_JawAndCone_UD210;
};
